import type ItemViewState from '../store/schema/ItemViewState';
import getStore from '../store/Store';

export default function getUndoDarkMode(
    viewState: Pick<ItemViewState, 'itemId' | 'undoDarkMode'> | undefined
): boolean {
    return viewState
        ? (getStore().undoDarkModeByItemId.get(viewState.itemId) ?? viewState.undoDarkMode)
        : false;
}
